import { IonContent, IonPage, IonCol, IonRow, IonText, IonGrid, IonList, IonItem, IonLabel, IonIcon, IonCard, IonCardHeader, IonToolbar, IonTitle, IonCardContent, IonInput, IonButton, useIonViewWillEnter, IonSpinner, IonPopover, IonToast } from '@ionic/react';
import React, { useContext, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './FellowshipProfilePage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import { lockClosed, logOut, people, person, trash } from 'ionicons/icons';
import { useHistory } from 'react-router-dom';
import { UserRouteInfo, UserRouteKeys } from '../../routes/UserRoutes';
import { useDispatch, useSelector } from 'react-redux';
import { SelectCurrentUser, Update } from '../../store/UserSlice';
import ServerDBContext from '../../components/ServerDBContext/ServerDBContext';
import { SelectGroup, SelectGroupIds, SelectGroups, UpdateGroup } from '../../store/FellowshipSlice';
import IFellowshipGroup from '../../interfaces/IFellowshipGroup';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import ResetPassword from '../../components/ResetPassword/ResetPassword';

const FellowshipProfilePage: React.FC<IRouteInfo> = (props: IRouteInfo) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentUser = useSelector(SelectCurrentUser);
  const currentGroup = useSelector(SelectGroup);
  const [updateMessage, setUpdateMessage] = useState('');
  const [displayName, setDisplayName] = useState('');
  const dbService = useContext(ServerDBContext);
  const [displayResetPassword, setDisplayResetPassword] = useState(false);
  const [showRemoveMemberConfirmation, setShowRemoveMemberConfirmation] = useState(false);
  const [removeMemberConfirmationEvent, setRemoveMemberConfirmationEvent] = useState<Event | undefined>(undefined);
  const [toastSuccessMessage, setToastSuccessMessage] = useState('Success');
  const [toastSuccessDuration, setToastSuccessDuration] = useState(25000);
  const [displayToastSuccess, setDisplayToastSuccess] = useState(false);
  const [displayToastFailed, setDisplayToastFailed] = useState(false);
  const [toastFailedMessage, setToastFailedMessage] = useState('Error');
  const userGroups = useSelector(SelectGroups);
  const userGroupIds = useSelector(SelectGroupIds);

  const saveProfile = () => {
    const updatedUser =  {...currentUser, displayName };
    setUpdateMessage('UPDATING PROFILE');
    const groupIds = userGroups ? Array.from(Object.keys(userGroups)) : [];
    dbService?.updateUser(updatedUser, groupIds).then(result => { 
      if(result.Success) {
        dispatch(Update(updatedUser));
        dbService?.getUserGroup(updatedUser.id).then(result => {
          if(result.Success){
            const group: IFellowshipGroup = result.Data!;
            dispatch(UpdateGroup(group))
            setUpdateMessage('SUCCESSFULLY UPDATED');
          } else {
          console.log("ERROR: User Updated but Group update failed");
          }
      }); 
      } else {
        setUpdateMessage('ERROR: FAILED TO UPDATE');
      }
    })
  }

  useIonViewWillEnter(() => {
    setDisplayName(currentUser.displayName!);
  }, [currentUser.displayName]);

  const removeMember = async (memberId: string) => {
    const removingMessage = 'Removing Member';
    console.log(toastSuccessMessage, isAdminWithGroupMembers())


    if(toastSuccessMessage !== removingMessage && !isAdminWithGroupMembers()) {
      setShowRemoveMemberConfirmation(false);
      setToastSuccessMessage(removingMessage);
      setToastSuccessDuration(25000);
      setDisplayToastSuccess(true);
      dbService?.deleteAccountAndMemberships(memberId)
        .then(result => {
          if(result.Success){
            setDisplayToastSuccess(false);
            setToastSuccessMessage('');
            if(currentUser.id === memberId){
              dbService.signOut();
              history.push(AppRouteInfo[AppRouteKeys.Fellowship].path, {direction: 'forward'});
            } else {
              dispatch(UpdateGroup(result.Data));
            }
          } else {
            setToastSuccessMessage('');
            setDisplayToastSuccess(false);
            setToastFailedMessage(result.Message.UserMessage);
            setDisplayToastFailed(true);
          }
        });
    }
  }

  const isAdminWithGroupMembers = () => {
    let isAdminWithGroupMembers:boolean = false;
    userGroupIds?.forEach(id => {
      const isAdmin = !!userGroups && userGroups[id]?.group.creatorId === currentUser.id;
      isAdminWithGroupMembers = isAdminWithGroupMembers || (isAdmin && userGroups[id]?.group.memberIds.length > 1);
    });
    return isAdminWithGroupMembers;
  }
  
  const pageHeaderMenuContent =
    <IonList className="fellowship-page-menu-list">
      <IonItem className="header-menu-item" onClick={() => {}}>
        <IonLabel>CHANGE PASSWORD</IonLabel>
        <IonIcon slot="start" icon={lockClosed}></IonIcon>
      </IonItem>
      <IonItem className="header-menu-item" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroup].path.replace('/:nav?', ''), { direction: 'forward' })}>
        <IonLabel>GROUP DETAILS</IonLabel>
        <IonIcon slot="start" icon={people}></IonIcon>
      </IonItem>
      <IonItem className="header-menu-item" onClick={()=>setShowRemoveMemberConfirmation(true)}>
        <IonLabel>DELETE ACCOUNT</IonLabel>
        <IonIcon slot="start" icon={trash}></IonIcon>
      </IonItem>
      <IonItem className="header-menu-item" onClick={()=>{
        dbService?.signOut();
        history.push(AppRouteInfo[AppRouteKeys.Fellowship].path, {direction: 'forward'});
      }}>
        <IonLabel>LOGOUT</IonLabel>
        <IonIcon slot="start" icon={logOut}></IonIcon>
      </IonItem>
    </IonList>;


  return (
    <IonPage>
      <PageHeader {...props} showBackButton={true} menuContents={pageHeaderMenuContent}></PageHeader>
      <IonContent className="fellowship-content">
        <IonGrid fixed={true}>
          <IonRow >
            <IonCol>
              <IonCard className="fellowship-profile-card" mode="md">
                <IonCardHeader>
                  <IonToolbar mode='md'>
                    <IonIcon size='large' slot="start" icon={person}></IonIcon>
                    <IonTitle>{currentUser.displayName}</IonTitle>
                  </IonToolbar>
                  <IonCardContent>
                    <IonList className="profile-list-items">
                      <IonItem>
                        <IonInput label="EMAIL:" disabled={true} value={currentUser.email}></IonInput>
                      </IonItem>
                      <IonItem>
                        <IonInput label="NAME:" value={displayName} onIonChange={e => setDisplayName(e.detail.value?.toString()!)}></IonInput>
                      </IonItem>
                    </IonList>
                    {
                      updateMessage === 'UPDATING PROFILE' ? 
                        <IonText className="login-message" color="primary">
                          <IonSpinner name="dots" color="primary"/><br />
                          {updateMessage}
                        </IonText> : 
                      updateMessage === 'SUCCESSFULLY UPDATED' ?
                        <IonText className="login-message" color="success">
                          {updateMessage}
                        </IonText> :
                        <IonText className="login-message" color="danger">
                          {updateMessage}
                        </IonText> 
                    }
                    <IonButton disabled={updateMessage === 'UPDATING PROFILE'} color="tertiary" expand="block" onClick={saveProfile}>
                      <IonLabel>
                        SAVE PROFILE
                      </IonLabel>
                    </IonButton>
                    <IonButton color="danger" expand="block" onClick={() => setDisplayResetPassword(true)}>
                      <IonLabel>
                        RESET PASSWORD
                      </IonLabel>
                    </IonButton>
                  </IonCardContent>
                </IonCardHeader>
              </IonCard>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <div onClick={()=>setShowRemoveMemberConfirmation(true)} className="delete-account-link">
                <span><IonIcon icon={trash}></IonIcon> DELETE ACCOUNT</span>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonPopover
          mode="md"
          isOpen={displayResetPassword}
          onDidDismiss={() => {
              setDisplayResetPassword(false);
          }}
        > 
          <ResetPassword email={currentUser.email} />
      </IonPopover>
      {/* Delete confirmation pop up */}
      <IonPopover
            mode="md"
            isOpen={showRemoveMemberConfirmation}
            event={removeMemberConfirmationEvent}
            onDidDismiss={() => {
                setShowRemoveMemberConfirmation(false); 
                setRemoveMemberConfirmationEvent(undefined);
            }}
        > { isAdminWithGroupMembers() ?
          <div className="delete-account-pop-over-message">
            <b>DELETE ACCOUNT:</b><br />
            {currentUser.displayName}
            <p>
              <b>NOTE:</b> Group admin's must first remove all the other members of their groups using the Group Details page and then they can delete their own account and close their groups.
            </p>
            <IonButton expand="block" color="danger" onClick={() => setShowRemoveMemberConfirmation(false)}>
              <IonLabel>CANCEL</IonLabel>
            </IonButton>
          </div> :
          <div>
            <div className="delete-account-pop-over-message">
              <b>DELETE ACCOUNT:</b><br />
              {currentUser.displayName}
                <p>
                  <b>Note:</b> <i>If you select yes, you will be permanently removed from your groups and unable to log into it again and any backed up prayers or reading plan data in the cloud will be deleted. Prayers and Reading Plans on this device will not be altered.</i>
                </p>
            </div>
            <IonButton expand="block" color="success" onClick={() => currentUser && removeMember(currentUser.id)}>
              <IonIcon icon={trash} slot="start"></IonIcon>
              <IonLabel>YES</IonLabel>
            </IonButton>
            <IonButton expand="block" color="danger" onClick={() => setShowRemoveMemberConfirmation(false)}>
              <IonLabel>CANCEL</IonLabel>
            </IonButton>
          </div>
          }
        </IonPopover>

        <IonToast color="success"
          isOpen={displayToastSuccess}
          onDidDismiss={() => setDisplayToastSuccess(false)}
          message={toastSuccessMessage}
          duration={toastSuccessDuration} />
        <IonToast color="danger"
          isOpen={displayToastFailed}
          onDidDismiss={() => setDisplayToastFailed(false)}
          message={toastFailedMessage}
          duration={2500} />
      </IonContent>
    </IonPage>
  );
};

export default FellowshipProfilePage;